module.exports = __webpack_public_path__ + "media/images/graph-4ad449684cf81e28f4b12ea42dffe207.svg";